import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getFocus } from '@/api/attention'

export function useFocus(ownerId?: string | null) {
  return useQuery({
    // ['attention'] stays first so the existing invalidations (deal saves, tasks, sends) still reach it.
    queryKey: ['attention', ownerId ?? null],
    queryFn: () => getFocus(ownerId),
    placeholderData: keepPreviousData,
  })
}
